export default __webpack_public_path__ + "26113f34f2dc4f56e9cd676f5e287d4c.png";